import axios from "axios"
// 定义服务器地址
//const URL = "http://localhost:6600";
//a. 配置所有请求的前缀 /api
//axios.defaults.baseURL = "http://192.168.112.115:5000/";
//axios.defaults.baseURL = "http://192.168.0.85:5271";
axios.defaults.baseURL = "https://www.yells.com.cn/wanghs";
//2. 配置请求超时时间
axios.defaults.timeout = 5000;//以毫秒为单位
/*3 axios 拦截请求*/
axios.interceptors.request.use(config => {
        //拦截成功   默认参数config  为请求头 切记拦截成功之后  必须返回配置 检测是否存在_token
        let token = localStorage.getItem("token");
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        }
        //config.baseURL = process.env.VUE_APP_URL  //配置请求文件的基础路径 跨域请求
        return config;
    },
    error => {//拦截失败
        return Promise.reject(error);
    }
);
// 4. 对返回的响应数据进行提前解析。方便使用返回的数据--响应拦截器
axios.interceptors.response.use((res) => {
    //res就是返回的响应数据
    return res.data;//会作为实际的响应数据返回到页面上
},error => {
    //请求失败或超时会执行的函数
    return Promise.reject(error);
});
//取消请求； cancelToken
export default axios
